<template>
    <div class="dinner-wrapper">
        <!--ページトップ部分-->
        <dinnerdetail :header="header" :datas="datas"></dinnerdetail>
        <div class="wrapper-50">
            <h2 class="text-4xl">個室のご案内</h2>
            <br>
            <p>当店のお部屋は完全個室となっております。他のお客様を気にすることなく、ゆったりとお食事をお楽しみいただけます。</p>
            <br>
            <div class="my-4 pt-4">
                <p class="text-xl mb-4 pb-4 border-bottom">2〜4人でご利用の場合のイメージ</p>
                <img class="max-w-full" src="@/assets/images/zaisu/zaisu_four.jpg" alt="座椅子4人用">
            </div>
            <div class="my-4 pt-4"> 
                <p class="text-xl mb-4 pb-4 border-bottom">6〜8人でご利用の場合のイメージ</p>
                <img class="max-w-full" src="@/assets/images/zaisu/zaisu_eight.jpg" alt="座椅子8人用">
            </div>
            <div class="my-4 pt-4"> 
                <p class="text-xl mb-4 pb-4 border-bottom">大人数でのご利用の場合のイメージ</p>
                <img class="max-w-full" src="@/assets/images/zaisu/zaisu_large.jpg" alt="座椅子大人数用">
            </div>
        </div>
        <!--ページのメインの部分-->
        <dinnermenu :datas="dinnermenu"></dinnermenu>

        <!-- コース料理の一例 -->
        <div class="wrapper-50 course-example">
            <h2 class="text-3xl mb-6">コース料理の一例</h2>
            <p class="text-lg mb-4">お任せコース 5000円</p>
            <p class="course-note">※ コース内容は一例です。季節や仕入れ状況により内容が変わります。</p>
            <div class="course-image-container">
                <img class="course-image" src="@/assets/images/fukumatu_food.jpg" alt="コース料理の一例">
            </div>
        </div>
    </div>
</template>
<script>
import dinnerdetail from '@/components/Parts/dinnerdetail.vue'
import dinnermenu from '@/components/Parts/DinnerMenu.vue'
export default {
    components:{
        dinnerdetail,
        dinnermenu,
    },
    data:function(){
        return{
            dinnermenu:[
                {
                    title:'季節コース',
                    text:'季節の食材を使った会席料理。コース値段によって中身の食材がかわります。',
                    // img:require('@/assets/images/enkai-basic.jpg'),
                    alt:"季節コース",
                    menu_style:"background-color:rgba(245,222,179,0.5);",
                    menu:{ price:'3000円〜（応相談）'}
                },
                {
                    title:'お任せコース',
                    text:'とにかく旨いものが食べたいというグルメ好きにおすすめです。食材にこだわりをもって旬の会席料理をお出し致します。',
                    // img:require('@/assets/images/enkai-basic2.jpg'),
                    alt:"お任せコース",
                    menu_style:"background-color:rgba(222,187,135,0.5);",
                    menu:{ price:'5000円〜（応相談）'}
                },
                {
                    title:'ふぐコース',
                    text:'ふぐコースは期間限定で下関のとらふぐをうすづくり、からあげ、鍋などふぐづくしのフルコースです。',
                    // img:require('@/assets/images/fugu.jpg'),
                    alt:"ふぐコース",
                    menu_style:"background-color:rgba(255,255,255,0.5);",
                    menu:{ price:'8000〜9000円（時価）' }
                },
                {
                    title:'伊勢コース',
                    text:'活けの伊勢えびを1人に1尾ずつお付けした贅沢なコースです。特別な日のお祝いにぜひご利用ください。',
                    // NOTE: 画像がないためコメントアウト
                    // img:require('@/assets/images/enkai-jyou.jpg'),
                    alt:"伊勢コース",
                    menu_style:"background-color:rgba(255,240,230,0.5);",
                    menu:{ price:'9000円〜（時価）' }
                },
                {
                    title:'特別懐石',
                    text:'特別な日の大切な方との思い出に。最高の料理で素晴らしいひと時をお過ごしください。',
                    // NOTE: 画像がないためコメントアウト
                    // img:require('@/assets/images/enkai-jyou.jpg'),
                    alt:"特別懐石",
                    menu_style:"background-color:rgba(240,230,220,0.5);",
                    menu:{ price:'10000円〜（応相談）' }
                }
            ]
        }
    }
}
</script>
<style scoped lang="scss">
@import '@/assets/variables.scss';
.wrapper-50{
    margin:50px auto;
    width:50%;
    @include lg(){
         min-width:850px;
    }
    @include md(){
        width:80%;
         min-width:850px;
    }
    @include sp(){
        width:90%;
    }
}
.border-bottom {
    border-bottom:1px solid rgba(0,0,0,0.3);
    box-shadow:0 5px 10px -10px black;
}
.dinner-wrapper{
    overflow:hidden;
    width:100vw;
}
.course-example{
    margin-top:80px;
    margin-bottom:80px;
    text-align:center;
    .course-image-container{
        margin:20px 0;
    }
    .course-image{
        max-width:100%;
        border-radius:8px;
        box-shadow:0 4px 12px rgba(0,0,0,0.1);
    }
    .course-note{
        margin-top:20px;
        font-size:0.9rem;
        color:#666;
    }
}
</style>